import {PromoRepository} from '@domain/model/Order';
import {PromoCodeApplication} from '@application/PromoCode';

const RemovePromoCode = (promoRepository: PromoRepository) => async (): Promise<void> => {
  await promoRepository.removePromoCode();
  PromoCodeApplication.clearBoxRequestPromoCode();
};

export {RemovePromoCode};
